<template>
    <div
        class="user-info"
        :class="{'user-info--loading' : isBalanceLoading}"
    >
        <div
            @click="$emit('profileClick')"
            class="user-badge"
        >
            <span
                v-if="isBalanceLoading"
                class="spinner spinner-dots"
            >
            </span>
            <i
                v-else
                class="icon icon--md icon-user_circle_2 user-icon"
            >
                <div
                    v-if="notifications.length"
                    class="notifications-indicator"
                />
            </i>
            <div class="hidden-below--tSm">
                <span class="username">{{ user.username }}</span>
                <div class="balance">
                    {{ userBalanceWithBonus  | currency(true) }}
                </div>
            </div>
        </div>
        <AccountMenu
            :class="{ 'is-expanded': isExpanded }"
            :notifications="notifications"
            :balance="userBalance"
            :bonus="userBonus"
            :sessionLength="sessionLength"
            @logout="onLogout"
            @notificationClick="onNotificationClick"
        />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { differenceInSeconds } from 'date-fns';
    import { routeNames } from '@app/router';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { NotificationType } from '@models/user/enums';
    import { errorGuard } from '@app/utils';
    import { SESSION_START } from '@store/modules/data/authentication/authenticationIndex';
    import ClientStorage from '@core/utils/storage/ClientStorage';
    import AccountMenu from './AccountMenu';

    export default {
        props: {
            isExpanded: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                sessionLength: 0,
            };
        },
        created() {
            /*
                Calculates the session length in minutes and sets an interval
                in which it's updated
            */
            const secondsDifference = differenceInSeconds(new Date(), new Date(this.sessionStart));
            this.sessionLength = Math.floor(secondsDifference / 60);
            const secondsTillFullMinute = 60 - (secondsDifference - this.sessionLength * 60);
            this.timeout = setTimeout(() => {
                this.interval = setInterval(() => {
                    this.sessionLength += 1;
                }, 60 * 1000);
            }, secondsTillFullMinute * 1000);
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
                'userBalance',
                'userBonus',
                'userBalanceWithBonus',
            ]),
            ...mapGetters('ui/user/notifications', [
                'notifications',
            ]),
            ...mapGetters('ui/user/account', [
                'isBalanceLoading',
            ]),
            sessionStart() {
                return ClientStorage.get(SESSION_START);
            }
        },
        methods: {
            ...mapActions('data/authentication', [
                'logout',
            ]),
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            onLogout() {
                errorGuard({
                    action: () => this.logout()
                });
            },
            onNotificationClick(type) {
                const modals = {
                    [NotificationType.sms]: Modals.smsValidation.code,
                    [NotificationType.idCard]: Modals.idCardVerificationIntro.code,
                    [NotificationType.idCardVerificationPending]: Modals.idCardVerification.code,
                    [NotificationType.idCardVerificationApproved]: Modals.idCardVerificationApproved.code,
                    [NotificationType.completeRegistration]: Modals.completeRegistration.code,
                };

                switch (type) {
                    case NotificationType.lowBalance:
                        this.$router.push({ name: routeNames.deposit });
                        break;
                    case NotificationType.idCard:
                    case NotificationType.sms:
                    case NotificationType.idCardVerificationPending:
                    case NotificationType.idCardVerificationApproved:
                    case NotificationType.completeRegistration:
                        this.setModal(modals[type]);
                        break;
                    default:
                        throw new Error('Wrong notification type!');
                }
            }
        },
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            } else {
                clearTimeout(this.timeout);
            }
        },
        components: {
            AccountMenu,
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Account/AccountContainer.vue